<template>
    <div class="user_rsv_calendar_wrap loading_top_wrap">
        <div v-if="isLoading" class="loading_bg" style="z-index: 999; border-radius: 0px;">
                <div class="loading_wrap">
                <div class="loading_obj">
                    <svg class="spinner" width="60px" height="60px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                        <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                    </svg>
                </div>
            </div>
        </div>
        <div class="calendar_tool">
            <button class="btn btn_white ico" @click="setPreviousMonth()"><v-icon>mdi-chevron-left</v-icon></button>
            <div class="month_title">{{ selectedMonthString }}</div>
            <button class="btn btn_white ico" @click="setNextMonth()"><v-icon>mdi-chevron-right</v-icon></button>
            <button class="btn btn_xxs btn_white mgl_auto" @click="setNow()">{{ $t('popup_user_reservation.label_this_month') }}</button>
        </div>
        <div class="date_wrap">
            <ul class="weeks">
                <li>{{ $t('common.sun') }}</li>
                <li>{{ $t('common.mon') }}</li>
                <li>{{ $t('common.tue') }}</li>
                <li>{{ $t('common.wed') }}</li>
                <li>{{ $t('common.thu') }}</li>
                <li>{{ $t('common.fri') }}</li>
                <li>{{ $t('common.sat') }}</li>
            </ul>

            <div class="calendar_scroll_wrap">
                <ul class="days">
                    <ReservationHistoryCalendarCell v-for="(date, index) in dateArray" :key="index"
                        :date="date"
                        :reservationDic="reservationDic"
                        :selectedMonth="selectedMonth"
                        :selectedReservation="selectedReservation"
                        @action_SelectReservation="selectReservation"
                        @action_ReservationMouseOver="handleReservationMouseOver"/>
                </ul>
            </div>
            
            <ReservationPreviewOverlay
                :isShow="isShowPreview"
                :hoverEvent="hoverEvent"
                :reservation="hoverReservation"/>
        </div>
    </div>
</template>


<script>
import { deepCopy } from '@/util/deep-copy'
const moment = require('@/util/MPMoment')
import ReservationPreviewOverlay from './ReservationPreviewOverlay.vue'
import ReservationHistoryCalendarCell from './ReservationHistoryCalendarCell.vue'
export default {
    components: { ReservationPreviewOverlay, ReservationHistoryCalendarCell },
    props: {
        hservice: Object,
        reservations: Array,
        note: String,
        selectedReservationID: String,
        isShow: Boolean
    },
    data() {
        return {
            selectedMonth: moment().startOf('months'),
            selectedReservation: undefined,

            currentMonthReservations: [],
            dateArray: undefined,
            reservationDic: {},

            hoverEvent: {},
            isShowPreview: false,
            hoverReservation: undefined,

            isLoading: false
        }
    },
    watch: {
        isShow: {
            handler: function(newValue) {
                if (newValue == false) {
                    this.selectReservation()
                }
            }
        },
        hservice: {
            immediate: true,
            handler: function() {
                this.setNow()
            }
        },
        reservations: {
            handler: function() {
                this.filterReservationsThisMonth()
            }
        },
        selectedMonth: {
            handler: function(newValue) {
                if (newValue == undefined) { return }
                this.generateDateArray()
                this.filterReservationsThisMonth()
            }
        },
        currentMonthReservations: {
            handler: function(newValue) {
                if (newValue == undefined) { return }
                this.generateReservationByDate()
            }
        },
    },
    computed: {
        selectedMonthString: function() {
            return this.selectedMonth?.format(this.$t('popup_user_reservation.calendar_month_format')) ?? ''
        },
    },
    methods: {
        setPreviousMonth() {
            this.selectedMonth = moment(this.selectedMonth).startOf('months').add(-1, 'months')
        },
        setNextMonth() {
            this.selectedMonth = moment(this.selectedMonth).startOf('months').add(1, 'months')
        },
        setNow() {
            this.selectedMonth = moment().startOf('months')
        },
        generateDateArray() {
            let firstDay = this.getFirstOverlapDate()

            this.dateArray = []
            for (let i = 0; i < 6 * 7; i++) {
                let d = moment(firstDay).add(i, 'days').startOf('days')
                this.dateArray.push(d)
            }
            this.$forceUpdate()
        },
        generateReservationByDate() {
            this.reservationDic = this.currentMonthReservations.reduce((dic, r) => {
                let key = moment(r.startedAt).format('YYYY-MM-DD')
                if (!dic[key]) {
                    dic[key] = []
                }
                dic[key].push(r)
                return dic
            }, {})
        },
        getFirstOverlapDate() {
            let startedAt = moment(this.selectedMonth).startOf('months')
            let dayIndex =  moment(startedAt).days()
            return moment(startedAt).add(-dayIndex, 'days')
        },

        selectReservation(reservation) {
            this.handleSetSelectedReservationID(reservation?._id)
            this.selectedReservation = reservation
        },

        handleSetSelectedReservationID(id) {
            this.$emit('setSelectedReservationID', id)
        },

        handleReservationMouseOver(reservation, hoverEvent, isShowPreview) {
            let rightPadding = 10
            let parentBoundingRect = this.$el.getBoundingClientRect()
            let xRelativeToParent = hoverEvent.x - parentBoundingRect.left + rightPadding
            let yRelativeToParent = hoverEvent.y - parentBoundingRect.top

            this.isShowPreview = isShowPreview

            const hoverReservation = deepCopy(reservation)
            if (hoverReservation) {
                hoverReservation.userTreatmentMemo = this.note
            }

            this.hoverReservation = hoverReservation
            this.hoverEvent = {
                x : xRelativeToParent,
                y : yRelativeToParent
            }
        },
        filterReservationsThisMonth() {
            try {
                this.isLoading = true
                this.currentMonthReservations = []

                if (this.reservations == undefined || this.reservations.length == 0) return 

                const date = this.getFirstOverlapDate()
                const periodStart = moment(date)
                const periodEnd = moment(date).add(41, 'days') 
                
                this.currentMonthReservations = this.reservations.filter(r => {
                    const rStartedAt = moment(r.startedAt);
                    const rEndedAt = moment(r.endedAt);

                    return rStartedAt >= periodStart && rEndedAt <= periodEnd;
                })

            } catch (err) {
                console.log(err)
            } finally {
                this.isLoading = false
            }
        },
    }
}
</script>